import suriIndexImage from '../static/assets/suri_index.svg'

export default {
  suriIndexImage
}
